import {
  useWSModalCustom,
  WSElement,
  WSElementProps,
  WSModal,
  WSText
} from "@wingspanhq/fe-component-library";

const ModalSsnInfo: React.FC<{ onClose: () => void } & WSElementProps> = ({
  onClose: _onClose,
  ...elementProps
}) => (
  <WSModal title="What is this used for?" size="S" onClose={_onClose}>
    <WSElement {...elementProps}>
      <WSText.ParagraphSm color="gray600" mb="M">
        Your Social Security Number (SSN) is required for tax reporting
        purposes. As a U.S. person, your income will be reported to the IRS on a
        Form 1099, which requires your SSN or Individual Taxpayer Identification
        Number (ITIN).
      </WSText.ParagraphSm>
      <WSText.ParagraphSm color="gray600">
        This information is securely stored and only used for tax compliance
        purposes.
      </WSText.ParagraphSm>
    </WSElement>
  </WSModal>
);

export const useModalSsnInfo = () => useWSModalCustom(ModalSsnInfo);
